import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { BulkUploadService } from '../services/bulk-upload.service';
import { CourseService } from '../services/course.service';
import { NotificationService } from '../services/notification.service';
import { HandleUploadService } from 'src/app/shared/modules/shared/services/handle-upload.service';

@Component({
  selector: 'app-add-organisation',
  templateUrl: './add-organisation.component.html',
  styleUrls: ['./add-organisation.component.scss']
})
export class AddOrganisationComponent implements OnInit {
  loader = false;
  add_organization_form: FormGroup;
  save_organization = 'Add Organization';
  organization_id: string = '';
  organization_list = [];
  organization_name = ''
  org_type_id = '';
  submit_org = false;
  fieldMaxLength: number = 200;
  editOrgData: any = {};
  themeColors: any[] = [];
  selectedThemeColor: string = '';
  isFileDeleted: boolean = false;
  regexOrgName: any = /^(?![\s-])[A-Za-z\s-]+(?<![\s-])$/;
  regexSubDomainName: any = /^(?!-)[a-z-]+(?<!-)$/;
  regexDomainName: any = /^(?!-)[a-z0-9.-]+(?<!-)$/;
  regexUrl: any = /^(https?:\/\/)([\w\-]+\.)+[a-z]{2,6}(:\d+)?(\/.*)?$/i;

  constructor(private fb: FormBuilder,
    private course_service: CourseService,
    private bulk_upload: BulkUploadService,
    private ActivatRoute: ActivatedRoute,
    private router: Router,
    private ns: NotificationService,
    private handleUploadService: HandleUploadService) { }
  ngOnInit() {
    this.getOrganizationtype();
    this.organization_id = this.ActivatRoute.snapshot.queryParamMap.get('organisation_id');
    this.organization_name = this.ActivatRoute.snapshot.queryParamMap.get('org_name');
    this.org_type_id = this.ActivatRoute.snapshot.queryParamMap.get('type');

    this.add_organization_form = this.fb.group({
      organization_name: ['', [Validators.required, Validators.pattern(this.regexOrgName), Validators.maxLength(this.fieldMaxLength)]],
      org_type: ['', Validators.required],
      is_selected_domain_level: [false, Validators.required],
      is_subdomain: [false, Validators.required],
      is_domain: [false, Validators.required],
      org_domain: [''],
      org_subdomain: [''],
      org_image: [''],
      org_url: [''],
      org_image_path: [''],
      org_image_path_url: [''],
      org_theme_index: ['0']
    })

    //SHARE FORM WITH CHILD COMPONENT
    this.handleUploadService.addForm = this.add_organization_form;

    if (this.organization_id) {
      this.editOrganisation();
    }
  }

  get organization_form() { return this.add_organization_form.controls; }

  add_organization() {
    this.submit_org = true;

    //SEND FORM SUBMIT STATUS TO CHILD COMPONENT
    this.handleUploadService.sendSubmitFormStatus({ status: true, formSubmitStatus: this.submit_org });

    if (this.add_organization_form.invalid
      || (this.add_organization_form.value.is_selected_domain_level && !(this.add_organization_form.value.is_subdomain || this.add_organization_form.value.is_domain))
      || (this.add_organization_form.value.is_selected_domain_level && (this.add_organization_form.value.is_subdomain || this.add_organization_form.value.is_domain) && !this.add_organization_form.value.org_image_path)) {
      this.ns.showNotification('error', "Please provide all details of the organization");
      return
    }
    if (!this.organization_id) {
      this.add_organization_api();
    } else if (this.organization_id) {
      this.patch_organization();
    }
  }

  editOrganisation() {
    this.loader = true;
    this.course_service.get_organization(this.organization_id).pipe(finalize(() => {
      this.loader = false;
    })).subscribe(organization => {
      if (organization.data) {
        this.save_organization = 'Edit Organization';
        this.editOrgData = organization.data;
        this.add_organization_form.controls['organization_name'].setValue(this.editOrgData.name);
        this.add_organization_form.controls['org_type'].setValue(this.org_type_id)
        // For set org image data in edit form
        this.add_organization_form.controls['is_subdomain'].setValue(this.editOrgData.is_subdomain);
        this.add_organization_form.controls['is_domain'].setValue(this.editOrgData.is_domain);
        if (this.editOrgData.is_subdomain == true || this.editOrgData.is_domain == true) {
          this.add_organization_form.controls['org_image'].setValue(this.editOrgData.org_image);
          this.add_organization_form.controls['org_subdomain'].setValue(this.editOrgData.org_subdomain);
          this.add_organization_form.controls['org_url'].setValue(this.editOrgData.org_url);
          this.add_organization_form.controls['org_image_path_url'].setValue(this.editOrgData.org_image_url);
          this.add_organization_form.controls['org_image_path'].setValue(' :::' + this.editOrgData.org_image);

          // For domain level checkbox checked
          this.add_organization_form.controls['is_selected_domain_level'].setValue(this.editOrgData.is_subdomain || this.editOrgData.is_domain);
          this.add_organization_form.controls['org_domain'].setValue(this.editOrgData.org_domain);

          // for organization theme colors
          if (this.editOrgData.theme_colors && this.editOrgData.theme_colors.length > 0) {
            this.themeColors = this.editOrgData.theme_colors;
            const imageData = this.editOrgData.image_data;
            const themeIndex = this.themeColors.findIndex(item =>
              item.hex_color.toLowerCase() === imageData.hex_color.toLowerCase() &&
              item.rgb_color.length === imageData.rgb_color.length &&
              item.rgb_color.every((val: any, i: any) => val === imageData.rgb_color[i])
            );
            if (themeIndex > -1) {
              this.add_organization_form.get('org_theme_index').setValue(`${themeIndex}`);
            }
            this.onSelectTheme();
          }
          this.onToogleLevel();
          this.handleUploadService.sendSharedData({ editData: this.add_organization_form.value });
        }
      }
    },
      (error) => {
        this.ns.showNotification('error', error.message);
      });
  }
  getValue(event) {
    if (!event.target.value) {
      this.save_organization = 'Add Organization';
    }
  }

  add_organization_api() {
    this.loader = true;
    const postData = { ...this.add_organization_form.value };
    postData['name'] = this.add_organization_form.value.organization_name;
    postData['org_type_id'] = this.add_organization_form.value.org_type;
    postData['org_image'] = this.getOrgImagePath();
    if (!this.add_organization_form.value.is_selected_domain_level) {
      postData['is_subdomain'] = false;
      postData['is_domain'] = false;
    }
    delete postData['org_image_path'];
    delete postData['org_image_path_url'];
    this.course_service.add_organization(postData).pipe(finalize(() => {
      this.loader = false;
      this.submit_org = false;
    })).subscribe(organization => {
      this.ns.showNotification('success', "Organization has been successfully added.");    
      this.add_organization_form.reset();
      this.add_organization_form.controls['org_type'].setValue('');

      //RESET SHARE FORM WITH CHILD COMPONENT
      this.handleUploadService.sendSubmitFormStatus({ status: true, formSubmitStatus: false });
      this.handleUploadService.addForm = null;
      this.handleUploadService.allUploadedFiles = [];
      this.handleUploadService.allDeletedFiles = [];


      this.router.navigate(['/search_organisation']);
      this.organization_id = '';
     
    },
      (error) => {
        this.ns.showNotification('error', error.message);
      })
  }
  patch_organization() {
    this.loader = true;
    let name_org = '';
    name_org = this.add_organization_form.value.organization_name

    let body = {
      org_id: this.organization_id,
      name: name_org,
      org_type_id: this.add_organization_form.value.org_type,
      is_subdomain: this.add_organization_form.value.is_subdomain,
      org_subdomain: this.add_organization_form.value.org_subdomain,
      org_image: this.getOrgImagePath(),
      org_url: this.add_organization_form.value.org_url,
      org_theme_index: this.add_organization_form.value.org_theme_index,
      is_selected_domain_level: this.add_organization_form.value.is_selected_domain_level,
      is_domain: this.add_organization_form.value.is_domain,
      org_domain: this.add_organization_form.value.org_domain
    }
    this.course_service.patch_organization(body).pipe(finalize(() => {
      this.loader = false;
      this.submit_org = false;
    })).subscribe(org => {
      this.ns.showNotification('success', 'Organization details were successfully updated.');
      this.add_organization_form.reset();
      this.organization_id = '';
      this.add_organization_form.controls['org_type'].setValue('');
      this.save_organization = 'Add Organization';
      this.router.navigate(['/search_organisation']);

    },
      (err) => {
        this.ns.showNotification('error', err.message);
      })
  }
  org_type = [];
  getOrganizationtype() {
    this.loader = true;
    this.bulk_upload.getOrganizationType().pipe(finalize(() => {
      this.loader = false;
    })).subscribe(getType => {
      this.org_type = getType;
    })
  }
  reset() {
    this.add_organization_form.reset();
    this.add_organization_form.controls['org_type'].setValue('');
    this.save_organization = 'Add Organization';
    this.organization_id = '';
    this.router.navigate(['/add_organisation']);
  }

  /**
  * For show hide subdomain or domain level fields
  *
  * @param {Event} event - The checkbox field event.
  */
  onToogleLevel(event: Event | null = null) {
    const isSubdomainControl = this.add_organization_form.get('is_subdomain');
    const isDomainControl = this.add_organization_form.get('is_domain');
    const isDomainLevelChecked = event ? (<HTMLInputElement>event.target).checked : this.add_organization_form.value.is_selected_domain_level;
    if (isDomainLevelChecked) {
      isSubdomainControl.setValidators([Validators.required]);
      isDomainControl.setValidators([Validators.required]);
      this.setFieldsValidators(this.add_organization_form.value.is_subdomain);
    } else {
      isSubdomainControl.clearValidators();
      isDomainControl.clearValidators();
      this.clearFieldsValidators();
    }
    isSubdomainControl.updateValueAndValidity();
    isDomainControl.updateValueAndValidity();
    this.updateFieldsValidity();
  }

  /**
  * For show hide additional subdomain fields
  *
  * @param {Event} event - The checkbox field event.
  */
  onToogleSubdomain(event: Event | null = null) {
    let isSubdomainChecked = false;
    let isDomainChecked = false;
    if ((<HTMLInputElement>event.target).name == 'is_subdomain') {
      this.add_organization_form.get('is_subdomain').setValue(true);
      this.add_organization_form.get('is_domain').setValue(false);
      this.add_organization_form.get('org_domain').setValue('');
      isSubdomainChecked = event ? (<HTMLInputElement>event.target).checked : this.add_organization_form.value.is_subdomain;
    }
    else {
      this.add_organization_form.get('is_domain').setValue(true);
      this.add_organization_form.get('is_subdomain').setValue(false);
      this.add_organization_form.get('org_subdomain').setValue('');
      isDomainChecked = event ? (<HTMLInputElement>event.target).checked : this.add_organization_form.value.is_domain;
    }
    if (isSubdomainChecked || isDomainChecked) {
      this.setFieldsValidators(isSubdomainChecked);
    } else {
      this.clearFieldsValidators();
    }
    this.updateFieldsValidity();
  }

  /**
   * To set fields validity
   */
  setFieldsValidators(isSubdomainChecked: boolean) {
    if (isSubdomainChecked) {
      this.add_organization_form.get('org_domain').clearValidators();
      this.add_organization_form.get('org_subdomain').clearValidators();
      this.add_organization_form.get('org_subdomain').setValidators([Validators.required, Validators.pattern(this.regexSubDomainName), Validators.maxLength(this.fieldMaxLength)]);
    }
    else {
      this.add_organization_form.get('org_subdomain').clearValidators();
      this.add_organization_form.get('org_domain').clearValidators();
      this.add_organization_form.get('org_domain').setValidators([Validators.required, Validators.pattern(this.regexDomainName), Validators.maxLength(this.fieldMaxLength)]);
    }
    this.add_organization_form.get('org_url').setValidators([Validators.pattern(this.regexUrl), Validators.maxLength(this.fieldMaxLength)]);
  }

  /**
   * To clear fields validity
   */
  clearFieldsValidators() {
    this.add_organization_form.get('org_subdomain').clearValidators();
    this.add_organization_form.get('org_domain').clearValidators();
    this.add_organization_form.get('org_url').clearValidators();
  }

  /**
   * To update fields validity
   */
  updateFieldsValidity() {
    this.add_organization_form.get('org_subdomain').updateValueAndValidity();
    this.add_organization_form.get('org_domain').updateValueAndValidity();
    this.add_organization_form.get('org_url').updateValueAndValidity();
  }

  getOrgImagePath() {
    let orgImage = this.add_organization_form.value.org_image_path;
    orgImage = orgImage.split(':::');
    return orgImage[1];
  }

  /**
  * To cancel form and redirect back to search organization page
  */
  onDiscard() {
    this.router.navigate(['/search_organisation']);
  }

  /**
  * To get text color based on theme color
  */
  getTextColor(hex: string): string {
    // Luminance-based contrast check
    const r = parseInt(hex.substring(1, 3), 16);
    const g = parseInt(hex.substring(3, 5), 16);
    const b = parseInt(hex.substring(5, 7), 16);
    const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
    return luminance > 186 ? '#000000' : '#FFFFFF';
  }

  /**
  * To show selected theme color preview
  */
  onSelectTheme() {
    this.selectedThemeColor = this.themeColors[this.add_organization_form.get('org_theme_index').value].hex_color;
  }

  /**
  * To get field status
  */
  onGetFieldStatus(statusData: any) {
    if (statusData.fileDeleted) {
      this.isFileDeleted = statusData.fileDeleted;
    }
  }

}
